import React, { useEffect, useState } from "react";
import axios from "../../api/axios";

// MUI components
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
  Paper,
  IconButton,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Typography,
  MenuItem,
} from "@mui/material";
import Icon from "@mui/material/Icon";

// Custom components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function MapSalaryStructures() {
  const [MapSalaryStructures, setMapSalaryStructures] = useState([]);

  const [salaryStructures, setSalaryStructures] = useState([]);
  const [staffGroups, setStaffGroups] = useState([]);
  const [gradeLevels, setGradeLevels] = useState([]);
  const [steps, setSteps] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [currentItem, setCurrentItem] = useState({
    id: null,
    amount: "",
    salary_structures_id: "",
    staff_group_id: "",
    grade_level_id: "",
    step_id: "",
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Fetch Data
  const fetchMapSalaryStructures = async () => {
    try {
      const response = await axios.get("/map-salary-structure");
      setMapSalaryStructures(response.data);
    } catch (err) {
      console.error("Failed to fetch Salary Structures", err);
    }
  };

  const fetchSelectOptions = async () => {
    try {
      const [salaryRes, staffRes, gradeRes, stepRes] = await Promise.all([
        axios.get("/salary-structures"),
        axios.get("/staff-group"),
        axios.get("/grade-levels"),
        axios.get("/steps"),
      ]);

      setSalaryStructures(salaryRes.data);
      setStaffGroups(staffRes.data);
      setGradeLevels(gradeRes.data);
      setSteps(stepRes.data);
    } catch (err) {
      console.error("Failed to fetch select data", err);
    }
  };

  useEffect(() => {
    fetchMapSalaryStructures();
    fetchSelectOptions();
  }, []);

  const handleSave = async () => {
    try {
      const payload = {
        amount: currentItem.amount,
        salary_structures_id: currentItem.salary_structures_id,
        staff_group_id: currentItem.staff_group_id,
        grade_level_id: currentItem.grade_level_id,
        step_id: currentItem.step_id,
      };

      if (currentItem.id) {
        await axios.put(`/map-salary-structure/${currentItem.id}`, payload);
        setSnackbar({ open: true, message: "Salary Structures updated successfully" });
      } else {
        await axios.post("/map-salary-structure", payload);
        setSnackbar({ open: true, message: "Salary Structures added successfully" });
      }

      fetchMapSalaryStructures();
      setOpenDialog(false);
      setCurrentItem({
        id: null,
        amount: "",
        salary_structures_id: "",
        staff_group_id: "",
        grade_level_id: "",
        step_id: "",
      });
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    }
  };

  const handleEdit = (item) => {
    setCurrentItem({
      id: item.id,
      amount: item.amount || "",
      salary_structures_id: item.salary_structures_id || "",
      staff_group_id: item.staff_group_id || "",
      grade_level_id: item.grade_level_id || "",
      step_id: item.step_id || "",
    });
    setOpenDialog(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Mapped Salary Structure?")) {
      try {
        await axios.delete(`/map-salary-structure/${id}`);
        fetchMapSalaryStructures();
        setSnackbar({ open: true, message: "Mapped Salary Structure deleted successfully" });
      } catch (err) {
        console.error("Delete failed", err);
      }
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedItems = MapSalaryStructures.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Grid container justifyContent="space-between" alignItems="center" px={2} mb={2}>
          <Typography variant="h5">Map Salary Structures</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenDialog(true)}
            sx={{ color: "#fff" }}
          >
            Add New
          </Button>
        </Grid>

        <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 3 }}>
          <Table>
            {/* <TableHead>
              <TableRow sx={{ backgroundColor: "#f0f2f5" }}>
                <TableCell>#</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Salary Structure</TableCell>
                <TableCell>Staff Group</TableCell>
                <TableCell>Grade Level</TableCell>
                <TableCell>Step</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead> */}
            <TableBody>
              {paginatedItems.length > 0 ? (
                paginatedItems.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{item.amount}</TableCell>
                    <TableCell>
                      {salaryStructures.find(
                        (s) => String(s.id) === String(item.salary_structures_id)
                      )?.name || <em>--</em>}
                    </TableCell>
                    <TableCell>
                      {staffGroups.find((s) => String(s.id) === String(item.staff_group_id))
                        ?.name || <em>--</em>}
                    </TableCell>
                    <TableCell>
                      {gradeLevels.find((g) => String(g.id) === String(item.grade_level_id))
                        ?.name || <em>--</em>}
                    </TableCell>
                    <TableCell>
                      {steps.find((s) => String(s.id) === String(item.step_id))?.name || (
                        <em>--</em>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleEdit(item)}>
                        <Icon>edit</Icon>
                      </IconButton>
                      <IconButton color="error" onClick={() => handleDelete(item.id)}>
                        <Icon>delete</Icon>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No Map Salary Structures found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={MapSalaryStructures.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </TableContainer>
      </MDBox>

      {/* Add/Edit Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>
          {currentItem.id ? "Edit Salary Structure" : "Add New Salary Structure"}
        </DialogTitle>
        <DialogContent>
          <TextField
            type="number"
            label="Amount"
            fullWidth
            margin="normal"
            value={currentItem.amount}
            onChange={(e) => setCurrentItem({ ...currentItem, amount: e.target.value })}
          />

          <TextField
            select
            label="Salary Structure"
            fullWidth
            margin="normal"
            value={currentItem.salary_structures_id}
            onChange={(e) =>
              setCurrentItem({ ...currentItem, salary_structures_id: e.target.value })
            }
          >
            <MenuItem value="">
              <em>-- Select Salary Structure --</em>
            </MenuItem>
            {salaryStructures.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Staff Group"
            fullWidth
            margin="normal"
            value={currentItem.staff_group_id}
            onChange={(e) => setCurrentItem({ ...currentItem, staff_group_id: e.target.value })}
          >
            <MenuItem value="">
              <em>-- Select Staff Group --</em>
            </MenuItem>
            {staffGroups.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Grade Level"
            fullWidth
            margin="normal"
            value={currentItem.grade_level_id}
            onChange={(e) => setCurrentItem({ ...currentItem, grade_level_id: e.target.value })}
          >
            <MenuItem value="">
              <em>-- Select Grade Level --</em>
            </MenuItem>
            {gradeLevels.map((g) => (
              <MenuItem key={g.id} value={g.id}>
                {g.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Step"
            fullWidth
            margin="normal"
            value={currentItem.step_id}
            onChange={(e) => setCurrentItem({ ...currentItem, step_id: e.target.value })}
          >
            <MenuItem value="">
              <em>-- Select Step --</em>
            </MenuItem>
            {steps.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary" sx={{ color: "#fff" }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        message={snackbar.message}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default MapSalaryStructures;
